'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var optimizelySdk = require('@optimizely/optimizely-sdk');
var reactSdk = require('@optimizely/react-sdk');
var React = require('react');
var qs = require('qs');
var rioSdkWeb = require('@chegg/rio-sdk-web');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var useHasMounted = function () {
    var _a = __read(React.useState(false), 2), hasMounted = _a[0], setHasMounted = _a[1];
    React.useEffect(function () {
        setHasMounted(true);
    }, []);
    return hasMounted;
};

var SafeOptimizelyFeature = function (_a) {
    var _b;
    var feature = _a.feature, children = _a.children;
    var hasMounted = useHasMounted();
    var optimizely = React.useContext(reactSdk.OptimizelyContext).optimizely;
    // Adding check for a user id in case an un-initialized optimizely is passed
    if (!optimizely || !((_b = optimizely.user) === null || _b === void 0 ? void 0 : _b.id)) {
        // render children with the `isEnabled param set to false`
        return React.createElement(React.Fragment, null, children(false, {}, hasMounted, false));
    }
    return (React.createElement(reactSdk.OptimizelyFeature, { feature: feature }, function (isEnabled, variables, clientReady, didTimeout) {
        return children(isEnabled, variables, clientReady, didTimeout);
    }));
};

var DEV = 'dev';
var PROD = 'prod';
var FORCE_QUERY_KEY = 'force-exp-';
var FORCE_ALL_TO_CONTROL = 'none0';
var CONTROL = 'control';
var PROJECT_KEY_DELIMITER = '|';
// For CheggEventSpec / RSW hooks
var ACTIVATION_TYPE = 'optimizely_allocation';
var DEFAULT_ALLOCATION_ID_TYPE = 'chegg_uvn';
// For cookie encoding:
var INDEX_DELIMITER = ',';
var KVP_DELIMITER = ':';
var USER_PROFILE_COOKIE = 'opt-user-profile';
var DEV_USER_PROFILE_COOKIE = "" + DEV + USER_PROFILE_COOKIE;
var PERSISTED_ATTRIBUTES_COOKIE = 'opt-user-attributes';
var EVENT = 'event';
var STRING = 'string';
// For HTTP headers
var CHEGG_EXPERIMENTS_HEADER_NAME = 'Chegg-Experiments';
var HEADER_VARIATION_DELIMITER = '|';
// For StudyBreakMedia (ads) integration
var GAM_KEY = 'gam-';
var GAM_GLOBAL_KVP_NAMESPACE = '_sbmGetOptimizelyGamKvps';
var RIO_VARIATIONS_LAYER_NAME = 'optimizelyVariationIds';
// For Optimizely Web integration
var DATA = 'data';
var STATE = 'state';
// SEM user tracking
var SEM_USER_QUERY_PARAM = 'c_id';
var SEM_USER_QUERY_PARAM_VALUE = 'sem';
// App-wide constants
var PACKAGE_NAME = '@chegg/optimizely-sdk';
// 512 charcters is enough for uvn length + 26 experiment ids 
var maxCookieLength = 512;

var constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DEV: DEV,
    PROD: PROD,
    FORCE_QUERY_KEY: FORCE_QUERY_KEY,
    FORCE_ALL_TO_CONTROL: FORCE_ALL_TO_CONTROL,
    CONTROL: CONTROL,
    PROJECT_KEY_DELIMITER: PROJECT_KEY_DELIMITER,
    ACTIVATION_TYPE: ACTIVATION_TYPE,
    DEFAULT_ALLOCATION_ID_TYPE: DEFAULT_ALLOCATION_ID_TYPE,
    INDEX_DELIMITER: INDEX_DELIMITER,
    KVP_DELIMITER: KVP_DELIMITER,
    USER_PROFILE_COOKIE: USER_PROFILE_COOKIE,
    DEV_USER_PROFILE_COOKIE: DEV_USER_PROFILE_COOKIE,
    PERSISTED_ATTRIBUTES_COOKIE: PERSISTED_ATTRIBUTES_COOKIE,
    EVENT: EVENT,
    STRING: STRING,
    CHEGG_EXPERIMENTS_HEADER_NAME: CHEGG_EXPERIMENTS_HEADER_NAME,
    HEADER_VARIATION_DELIMITER: HEADER_VARIATION_DELIMITER,
    GAM_KEY: GAM_KEY,
    GAM_GLOBAL_KVP_NAMESPACE: GAM_GLOBAL_KVP_NAMESPACE,
    RIO_VARIATIONS_LAYER_NAME: RIO_VARIATIONS_LAYER_NAME,
    DATA: DATA,
    STATE: STATE,
    SEM_USER_QUERY_PARAM: SEM_USER_QUERY_PARAM,
    SEM_USER_QUERY_PARAM_VALUE: SEM_USER_QUERY_PARAM_VALUE,
    PACKAGE_NAME: PACKAGE_NAME,
    maxCookieLength: maxCookieLength
});

var ensureUserId = function (optimizelyInstance, explicitUserId) {
    var _a, _b;
    var user_id = explicitUserId || ((_b = (_a = optimizelyInstance) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.id);
    if (!user_id) {
        console.error('OPTIMIZELY: user id is not set.');
    }
    return user_id;
};
var ensureOptConfig = function (optimizelyInstance) {
    var config = optimizelyInstance.getOptimizelyConfig();
    if (!config) {
        console.error('OPTIMIZELY: optimizely config is not fetched.');
    }
    return config;
};

/**
 * @remarks
 * Parses a query string to return an array of { experiment, variation } pairs.
 *
 * @param queryStringParams- ParsedQs
 * @returns ReadableExperimentVariation[]
 *
 */
var parseForcedExperiments = function (queryStringParams) {
    return Object.entries(queryStringParams)
        .filter(function (kv) {
        var _a = __read(kv, 2), queryKey = _a[0], variation = _a[1];
        return queryKey.startsWith(FORCE_QUERY_KEY) && typeof variation === STRING;
    })
        .map(function (_a) {
        var _b = __read(_a, 2), queryKey = _b[0], variation = _b[1];
        var experiment = getExperimentKey(queryKey);
        return { experiment: experiment, variation: variation };
    });
};
/**
 * @remarks
 * Determines if a query string includes any forced experiments.
 *
 * @param queryStringParams- ParsedQs
 * @returns boolean
 *
 */
var hasForcedExperiment = function (queryStringParams) {
    return parseForcedExperiments(queryStringParams).length > 0;
};
/**
 * @remarks
 * https://chegg.atlassian.net/browse/LSE-167
 * PHP integration requires a "project key" within a force url to specify the project datafile.
 * TS is currently built to manage a single project at a time, so project key is unnecessary.
 * This library must be able to recieve a query string with project key and
 * still apply the "force" behavior.
 * This function safely strips "force-exp" and possible project key
 * and returns just the experiment name.
 *
 * @param queryKey - string - Given `?force-exp-experimentName=variationName`,
 * `qs` will parse the string to key value pairs. This function receives
 * a key, such as "force-exp-experimentName".
 *
 * @returns experiment key string
 *
 */
var getExperimentKey = function (queryKey) {
    var omitForceKey = queryKey.slice(FORCE_QUERY_KEY.length);
    return omitForceKey.split(PROJECT_KEY_DELIMITER).pop();
};

var isReactSDKClient = function (client) {
    return typeof client.setUser === 'function';
};
/**
 * @remarks
 * Parses a query string to return a map of query params and values.
 *
 * @param queryString - string - access via DOM api `window.location.search`
 *
 */
var parseQueryStringForParams = function (queryString) {
    return qs.parse(queryString, {
        ignoreQueryPrefix: true,
        parseArrays: false,
    });
};

var persist = function (experiment, variation, userProfileService, user_id, optConfig) {
    var _a;
    var userProfile = userProfileService.lookup(user_id);
    var experiment_bucket_map = userProfile ? userProfile.experiment_bucket_map : {};
    var coercedExp = optConfig.experimentsMap[experiment];
    var experimentId = coercedExp.id;
    var variation_id = coercedExp.variationsMap[variation].id;
    userProfileService.save({
        user_id: user_id,
        experiment_bucket_map: __assign(__assign({}, experiment_bucket_map), (_a = {}, _a[experimentId] = { variation_id: variation_id }, _a)),
    });
};
var warnNoControl = function (experimentKey) {
    console.error("[@chegg/optimizely-sdk]: experiment \"" + experimentKey + "\" does not contain a \"" + CONTROL + "\" variation. This violates the contract with chegg's sdk. Ensure every experiment contains a \"" + CONTROL + "\" variation for consistent results in QA.");
};
var warnNoExperiment = function (experimentKey) {
    console.error("[@chegg/optimizely-sdk]: Unable to find optimizely experiment \"" + experimentKey + "\" in config. \nCheck query string spelling, and confirm experiment is published.");
};
var addExperimentControlVariations = function (forcedExperiments, _a) {
    var experimentsMap = _a.experimentsMap;
    var withoutForceAllControl = forcedExperiments.filter(function (_a) {
        var experiment = _a.experiment;
        return experiment !== FORCE_ALL_TO_CONTROL;
    });
    if (forcedExperiments.length === withoutForceAllControl.length) {
        return forcedExperiments;
    }
    return Object.entries(experimentsMap).reduce(function (acc, _a) {
        var _b = __read(_a, 2), experimentKey = _b[0], experiment = _b[1];
        var individuallyForced = withoutForceAllControl.some(function (v) { return v.experiment === experimentKey; });
        if (individuallyForced) {
            return acc;
        }
        var noControl = !experiment.variationsMap[CONTROL];
        if (noControl) {
            warnNoControl(experimentKey);
            return acc;
        }
        var experimentVariation = {
            experiment: experimentKey,
            variation: CONTROL,
        };
        return __spread([experimentVariation], acc);
    }, withoutForceAllControl);
};
var applyForcedAllocations = function (_a) {
    var optimizely = _a.optimizely, forcedExperiments = _a.forcedExperiments, optConfig = _a.optConfig, user_id = _a.user_id, userProfileService = _a.userProfileService;
    addExperimentControlVariations(forcedExperiments, optConfig).forEach(function (_a) {
        var experiment = _a.experiment, variation = _a.variation;
        var coercedExp = optConfig.experimentsMap[experiment];
        if (!coercedExp) {
            warnNoExperiment(experiment);
            return;
        }
        // This only persists variation for the runtime of this client instance.
        optimizely.setForcedVariation(experiment, user_id, variation);
        persist(experiment, variation, userProfileService, user_id, optConfig);
    });
};
function forceAllocationsOnReady(optimizelyInstance, userProfileService, search, explicitUserId) {
    return __awaiter(this, void 0, void 0, function () {
        var allocationsApplied, queryStringParams, forcedExperiments, user_id, optConfig, reactSdkClient_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    allocationsApplied = false;
                    return [4 /*yield*/, optimizelyInstance.onReady()];
                case 1:
                    _a.sent();
                    queryStringParams = search ? parseQueryStringForParams(search) : {};
                    forcedExperiments = parseForcedExperiments(queryStringParams);
                    user_id = ensureUserId(optimizelyInstance, explicitUserId);
                    optConfig = ensureOptConfig(optimizelyInstance);
                    if (!user_id && optimizelyInstance.onUserUpdate) {
                        reactSdkClient_1 = optimizelyInstance;
                        reactSdkClient_1.onUserUpdate(function () {
                            if (!reactSdkClient_1.user.id || allocationsApplied) {
                                return;
                            }
                            applyForcedAllocations({
                                forcedExperiments: forcedExperiments,
                                userProfileService: userProfileService,
                                optConfig: optConfig,
                                optimizely: optimizelyInstance,
                                user_id: reactSdkClient_1.user.id,
                            });
                            allocationsApplied = true;
                        });
                        return [2 /*return*/];
                    }
                    if (!user_id || !optConfig) {
                        console.error('[@chegg/optimizely-sdk]: exiting before applying forced allocations.');
                        return [2 /*return*/];
                    }
                    applyForcedAllocations({
                        userProfileService: userProfileService,
                        forcedExperiments: forcedExperiments,
                        optConfig: optConfig,
                        optimizely: optimizelyInstance,
                        user_id: user_id,
                    });
                    allocationsApplied = true;
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * @deprecated Use parseForcedExperiments instead
 */
var parseForcedAllocations = function (_optimizelyInstance, _queryStringMap) {
    return [];
};

var createGetCheggExperimentsHeader = function (getEnrichedUserProfile) {
    return function (overrideId) {
        var _a;
        var enrichedUserProfile = getEnrichedUserProfile(overrideId);
        var variationsString = enrichedUserProfile
            .map(function (_a) {
            var id = _a.variation.id;
            return id;
        })
            .sort()
            .join(HEADER_VARIATION_DELIMITER);
        return _a = {},
            _a[CHEGG_EXPERIMENTS_HEADER_NAME] = variationsString,
            _a;
    };
};

/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

var getRioClient = function (namespace) {
    return rioSdkWeb.getClient(namespace);
};
var getRioAllocationState = function (namespace) { var _a, _b, _c; return ((_c = (_b = (_a = getRioClient(namespace)) === null || _a === void 0 ? void 0 : _a.stateManager) === null || _b === void 0 ? void 0 : _b.get()) === null || _c === void 0 ? void 0 : _c.experiments) || []; };
var rioSessionHasAllocation = function (rioSessionAllocations, newAllocation) {
    return rioSessionAllocations.some(function (prevAllocation) {
        return prevAllocation.experiment_id === newAllocation.experiment_id &&
            prevAllocation.variant_id === newAllocation.variant_id;
    });
};
var getAllocationTypeFromExperiment = function (rioConfig, experiment_id) {
    var defaultAllocationIdType = rioConfig.default_allocation_id_type || DEFAULT_ALLOCATION_ID_TYPE;
    if (!rioConfig.allocation_type_overrides) {
        return defaultAllocationIdType;
    }
    return rioConfig.allocation_type_overrides[experiment_id] || defaultAllocationIdType;
};
var setInitialRioState = function (optimizely, rioConfig, rioInitPromise) { return __awaiter(void 0, void 0, void 0, function () {
    var getUserContext, getCookie, unparsed, _a, userProfile, experiment_bucket_map, rioSessionAllocations_1, experiments;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                getUserContext = function () { return optimizely.user; };
                getCookie = function () { return api.get(getUserProfileCookieName(getUserContext)); };
                _a = getCookie();
                if (_a) return [3 /*break*/, 2];
                return [4 /*yield*/, optimizely.onReady()];
            case 1:
                _a = ((_b.sent()) && getCookie());
                _b.label = 2;
            case 2:
                unparsed = _a;
                if (!unparsed) {
                    return [2 /*return*/];
                }
                userProfile = decode(unparsed);
                experiment_bucket_map = userProfile.experiment_bucket_map;
                _b.label = 3;
            case 3:
                _b.trys.push([3, 6, , 7]);
                if (!(rioConfig === null || rioConfig === void 0 ? void 0 : rioConfig.rioInitPromise)) return [3 /*break*/, 5];
                return [4 /*yield*/, rioConfig.rioInitPromise];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5:
                rioSessionAllocations_1 = getRioAllocationState(rioConfig === null || rioConfig === void 0 ? void 0 : rioConfig.rioNamespace);
                experiments = Object.entries(experiment_bucket_map)
                    .map(function (_a) {
                    var _b = __read(_a, 2), experiment_id = _b[0], variation_id = _b[1].variation_id;
                    return ({
                        experiment_id: experiment_id,
                        variant_id: variation_id,
                    });
                })
                    .filter(function (newAllocation) { return !rioSessionHasAllocation(rioSessionAllocations_1, newAllocation); });
                getRioClient(rioConfig === null || rioConfig === void 0 ? void 0 : rioConfig.rioNamespace).updateState({
                    experiments: experiments,
                });
                return [3 /*break*/, 7];
            case 6:
                _b.sent();
                console.error("[@chegg/optimizely-sdk]: Error setting initial Rio state");
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); };
var dispatchNewAllocations = function (newAllocations, rioConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var rioClient, rioSessionAllocations_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!rioConfig) {
                    return [2 /*return*/];
                }
                rioClient = getRioClient(rioConfig.rioNamespace);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                if (!rioConfig.rioInitPromise) return [3 /*break*/, 3];
                return [4 /*yield*/, rioConfig.rioInitPromise];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                rioSessionAllocations_2 = getRioAllocationState(rioConfig.rioNamespace);
                newAllocations.forEach(function (_a) {
                    var experiment_id = _a.experiment_id, variant_id = _a.variant_id, allocation_id = _a.allocation_id;
                    var newAllocation = { experiment_id: experiment_id, variant_id: variant_id };
                    if (rioSessionHasAllocation(rioSessionAllocations_2, newAllocation))
                        return;
                    var specs = {
                        type: ACTIVATION_TYPE,
                        data: __assign({ allocation_id: allocation_id, allocation_id_type: getAllocationTypeFromExperiment(rioConfig, experiment_id), project_id: rioConfig.project_id }, newAllocation),
                        eventVersion: 3,
                    };
                    rioClient.updateState({ experiments: [newAllocation] });
                    rioClient.sendEvent(specs);
                });
                return [3 /*break*/, 5];
            case 4:
                _a.sent();
                console.error("[@chegg/optimizely-sdk]: Error dispatching Rio events for new allocations");
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };

// https://docs.developers.optimizely.com/full-stack/docs/implement-a-user-profile-service-react
var newUserProfile = function () {
    return { user_id: '', experiment_bucket_map: {} };
};
/**
 * UserProfile is compressed to a string and encoded as
 * id,exp1:var1,exp2:var2[,...]
 * The cookie string is also url encoded as a precaution against transformation in request cycles
 */
var encode = function (userProfile) {
    var user_id = userProfile.user_id, experiment_bucket_map = userProfile.experiment_bucket_map;
    var compressedBucketMap = Object.keys(experiment_bucket_map).reduce(function (result, experimentId) {
        return "" + result + (result.length ? INDEX_DELIMITER : '') + experimentId + KVP_DELIMITER + experiment_bucket_map[experimentId].variation_id;
    }, '');
    return encodeURIComponent("" + user_id + INDEX_DELIMITER + compressedBucketMap);
};
var decode = function (wtCookieValue) {
    var _a = __read(decodeURIComponent(wtCookieValue).split(INDEX_DELIMITER)), user_id = _a[0], compressedBucketMap = _a.slice(1);
    if (!compressedBucketMap.length) {
        throw new Error('cookie encoding is corrupt');
    }
    var experiment_bucket_map = compressedBucketMap.reduce(function (decodedMap, keyValueString) {
        var _a = __read(keyValueString.split(KVP_DELIMITER), 2), key = _a[0], value = _a[1];
        decodedMap[key] = {
            variation_id: value,
        };
        return decodedMap;
    }, {});
    return { user_id: user_id, experiment_bucket_map: experiment_bucket_map };
};
var _lookup = function (userId, cookieName) {
    if (cookieName === void 0) { cookieName = USER_PROFILE_COOKIE; }
    try {
        var unparsed = api.get(cookieName);
        if (!unparsed) {
            return newUserProfile();
        }
        var userProfile = decode(unparsed);
        if (process.env.NODE_ENV === 'development' && userId !== userProfile.user_id) {
            console.error("[OPTIMIZELY] cookiePersistenceService#lookup user id has changed midsession from \"" + userId + "\" to \"" + userProfile.user_id + "\".");
        }
        return userProfile;
    }
    catch (error) {
        api.remove(cookieName);
        return newUserProfile();
    }
};
var getNewAllocations = function (newUserProfile, cookieName) {
    var oldBucketMap = _lookup(newUserProfile.user_id, cookieName).experiment_bucket_map;
    return Object.keys(newUserProfile.experiment_bucket_map).reduce(function (newExperiments, experimentKey) {
        if (oldBucketMap[experimentKey]) {
            return newExperiments;
        }
        var variant_id = newUserProfile.experiment_bucket_map[experimentKey].variation_id;
        return __spread(newExperiments, [{ experiment_id: experimentKey, variant_id: variant_id, allocation_id: newUserProfile.user_id }]);
    }, []);
};
var _save = function (userProfile, cookieDomain, cookieName, rioConfig) {
    if (cookieName === void 0) { cookieName = USER_PROFILE_COOKIE; }
    try {
        dispatchNewAllocations(getNewAllocations(userProfile, cookieName), rioConfig);
        var unparsed = api.get(cookieName);
        // this limits the cookie size to ~26 experiment IDs before it is deleted,
        // deleting the cookie will not reallocate users, but it will result in Rio
        // allocation events again for any active experiments on next _save() call
        if (unparsed && unparsed.length > maxCookieLength) {
            if (Object.prototype.hasOwnProperty.call(window, "newrelic")) {
                // Log a custom page action
                window.newrelic.addPageAction('message: Force cookie clean up for opt-user-profile; location: chegg-optimizely-sdk; severity: WARN');
            }
            api.remove(cookieName, {
                domain: cookieDomain,
            });
        }
        else {
            api.set(cookieName, encode(userProfile), {
                domain: cookieDomain,
                expires: 365,
            });
        }
    }
    catch (error) {
        console.error('OPTIMIZELY: error encoding user profile to cookie. ', error);
    }
};
/**
 * @remarks Transforms a "light" user profile containing just experiment and variation ids to a
 * richer interface containing all named property for each experiment / variation pair from an
 * instance's OptimizelyConfig
 *
 *
 * @param { experiment_bucket_map } UserProfile.experiment_bucket_map
 * @param { experimentsMap } OptimizelyConfig.experimentsMap
 * @returns EnrichedUserProfile - list of all experiment variations, with all available data for each.
 */
var enrichUserProfile = function (_a, _b) {
    var experiment_bucket_map = _a.experiment_bucket_map;
    var experimentsMap = _b.experimentsMap;
    return Object.keys(experiment_bucket_map).reduce(function (list, experimentId) {
        var variation_id = experiment_bucket_map[experimentId].variation_id;
        var experimentKey = Object.keys(experimentsMap).find(function (name) { return experimentsMap[name].id === experimentId; });
        var experiment = experimentsMap[experimentKey];
        if (!experiment) {
            // this is not necessarily an error, datafile may have been updated since userprofile was written
            return list;
        }
        var variationsMap = experiment.variationsMap;
        var variationKey = Object.keys(variationsMap).find(function (name) { return variationsMap[name].id === variation_id; });
        var variation = variationsMap[variationKey];
        if (!variation) {
            return list;
        }
        return __spread(list, [
            {
                experiment: {
                    id: experimentId,
                    key: experimentKey,
                },
                variation: __assign({}, variation),
            },
        ]);
    }, []);
};
var transformToHumanReadable = function (userProfile, config) {
    return enrichUserProfile(userProfile, config).map(function (_a) {
        var experiment = _a.experiment, variation = _a.variation;
        return ({
            experiment: experiment.key,
            variation: variation.key,
        });
    });
};
var getUserProfileCookieName = function (getContext) {
    var _a, _b;
    if (!getContext) {
        return USER_PROFILE_COOKIE;
    }
    return ((_b = (_a = getContext()) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.deployEnv) === DEV ? DEV_USER_PROFILE_COOKIE : USER_PROFILE_COOKIE;
};
/**
 *
 * For visibility of cookies across all subdomains, ensure to prefix the cookie domain string with a `"."` ala `".chegg.com"` or `".easybib.com"`
 *
 */
var createCookiePersistenceService = function (cookieDomain, rioConfig) {
    var getContext;
    var save = function (userProfile) {
        _save(userProfile, cookieDomain, getUserProfileCookieName(getContext), rioConfig);
    };
    var lookup = function (userId) {
        return _lookup(userId, getUserProfileCookieName(getContext));
    };
    var assignContext = function (getUserContext) {
        getContext = getUserContext;
    };
    return {
        assignContext: assignContext,
        userProfileService: {
            save: save,
            lookup: lookup,
        },
    };
};

var cache = {};
var getEnrichedUserProfile = function (optimizely, userProfileService) {
    return function (overrideId) {
        var config = ensureOptConfig(optimizely);
        var userId = overrideId || ensureUserId(optimizely, overrideId);
        if (!(userId && config)) {
            return [];
        }
        var unparsedCookieValue = api.get(USER_PROFILE_COOKIE);
        if (!unparsedCookieValue)
            return [];
        if (!cache[unparsedCookieValue]) {
            var userProfile = userProfileService.lookup(userId);
            var enrichedUserProfile = enrichUserProfile(userProfile, config);
            cache[unparsedCookieValue] = enrichedUserProfile;
        }
        return cache[unparsedCookieValue];
    };
};

var useSafeOptimizelyFeature = function (featureKey, options, overrides) {
    var hasMounted = useHasMounted();
    var optimizely = React.useContext(reactSdk.OptimizelyContext).optimizely;
    // return early is ok here due to optimizely either existing or not, as it will not change
    if (!optimizely) {
        return {
            isEnabled: false,
            variables: {},
            clientReady: hasMounted,
            didTimeout: false,
        };
    }
    // eslint-disable-next-line
    var _a = __read(reactSdk.useFeature(featureKey, options, overrides), 4), isEnabled = _a[0], variables = _a[1], clientReady = _a[2], didTimeout = _a[3];
    return {
        isEnabled: isEnabled,
        variables: variables,
        clientReady: clientReady,
        didTimeout: didTimeout,
    };
};

var persistDevAttribute = function (reactSdkClient) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, reactSdkClient.onReady()];
            case 1:
                _a.sent();
                reactSdkClient.onUserUpdate(function (user) {
                    var _a;
                    var devCookie = api.get(DEV_USER_PROFILE_COOKIE);
                    // If the user has been assigned a dev cookie, they should not be counted under the "prod" deployEnv
                    if (devCookie && ((_a = user === null || user === void 0 ? void 0 : user.attributes) === null || _a === void 0 ? void 0 : _a.deployEnv) === PROD) {
                        reactSdkClient.setUser({
                            id: user.id,
                            attributes: __assign(__assign({}, user.attributes), { deployEnv: DEV }),
                        });
                    }
                });
                return [2 /*return*/];
        }
    });
}); };

var isSEMUser = function (queryStringParams) {
    return queryStringParams[SEM_USER_QUERY_PARAM] === SEM_USER_QUERY_PARAM_VALUE;
};

var defaultAttrs = {
    fromSEM: false,
    forcedExperiment: false,
};
function persistQueryStringAttributes(optimizelyInstance, search, cookieDomain) {
    return __awaiter(this, void 0, void 0, function () {
        var queryStringParams, prevAttrs, newAttrs, hasNewAttrs, persistedAttrs, attributes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryStringParams = search ? parseQueryStringForParams(search) : {};
                    prevAttrs = getPersistedAttrs();
                    newAttrs = getQueryStringAttrs(queryStringParams);
                    hasNewAttrs = Object.keys(newAttrs).length > 0;
                    persistedAttrs = __assign(__assign({}, prevAttrs), newAttrs);
                    if (hasNewAttrs) {
                        persistAttrs(persistedAttrs, cookieDomain);
                    }
                    return [4 /*yield*/, optimizelyInstance.onReady()];
                case 1:
                    _a.sent();
                    attributes = __assign(__assign({}, defaultAttrs), persistedAttrs);
                    setOptimizelyInstanceAttrs(optimizelyInstance, attributes);
                    return [2 /*return*/];
            }
        });
    });
}
function getPersistedAttrs() {
    try {
        var cookieValue = api.get(PERSISTED_ATTRIBUTES_COOKIE);
        return cookieValue ? JSON.parse(atob(decodeURIComponent(cookieValue))) : {};
    }
    catch (e) {
        console.error('[@chegg/optimizely-sdk]: Error getting persisted attributes');
        return {};
    }
}
function getQueryStringAttrs(queryStringMap) {
    var attributes = {};
    var fromSEM = isSEMUser(queryStringMap);
    // Only persist fromSEM when true
    if (fromSEM) {
        attributes.fromSEM = true;
    }
    var forcedExperiment = hasForcedExperiment(queryStringMap);
    // Only persist forcedExperiment when true
    if (forcedExperiment) {
        attributes.forcedExperiment = true;
    }
    return attributes;
}
function persistAttrs(attributes, cookieDomain) {
    try {
        var cookieValue = encodeURIComponent(btoa(JSON.stringify(attributes)));
        var expires = 14;
        api.set(PERSISTED_ATTRIBUTES_COOKIE, cookieValue, { expires: expires, domain: cookieDomain });
    }
    catch (e) {
        console.error('[@chegg/optimizely-sdk]: Error setting persisted attributes');
    }
}
function setOptimizelyInstanceAttrs(optimizelyInstance, attributes) {
    var setAttributes = function (user) {
        if (!isReactSDKClient(optimizelyInstance) || !user || attrsAreEqual(user.attributes, attributes)) {
            return;
        }
        try {
            optimizelyInstance.setUser({
                id: user.id,
                attributes: __assign(__assign({}, user.attributes), attributes),
            });
        }
        catch (e) {
            console.error('[@chegg/optimizely-sdk]: Error updating user with persisted attributes');
        }
    };
    if (isReactSDKClient(optimizelyInstance)) {
        setAttributes(optimizelyInstance.user);
        optimizelyInstance.onUserUpdate(setAttributes);
    }
}
function attrsAreEqual(userAttributes, attributes) {
    return Object.entries(attributes).every(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return userAttributes[key] === value;
    });
}

var gamKeyRegex = new RegExp(GAM_KEY + "[a-z]$", 'i');
var _sbmGetOptimizelyGamKvps = function (getEnriched, projectGamKeyPrefix) { return function (overrideId) {
    var enrichedUserProfile = getEnriched(overrideId);
    return __spread(getWebExperiments(projectGamKeyPrefix), getFsExperiments(enrichedUserProfile, projectGamKeyPrefix));
}; };
var setGamGlobal = function (getEnriched, projectGamKeyPrefix) {
    var getGamKvps = _sbmGetOptimizelyGamKvps(getEnriched, projectGamKeyPrefix);
    Object.defineProperty(window, GAM_GLOBAL_KVP_NAMESPACE, {
        value: getGamKvps,
        configurable: false,
        writable: false,
    });
};
var getWebExperiments = function (projectGamKeyPrefix) {
    var _a, _b, _c;
    var emptyList = [];
    if (((_a = window.optimizely) === null || _a === void 0 ? void 0 : _a.get) === undefined) {
        return emptyList;
    }
    var experiments = ((_b = window.optimizely) === null || _b === void 0 ? void 0 : _b.get(DATA)).experiments;
    var getVariationMap = ((_c = window.optimizely) === null || _c === void 0 ? void 0 : _c.get(STATE)).getVariationMap;
    var webExperiments = getVariationMap();
    return Object.keys(webExperiments).reduce(function (list, key) {
        var experiment = experiments[key];
        if (experiment === undefined || !gamKeyRegex.test(experiment.name)) {
            return list;
        }
        var value = webExperiments[key];
        var variant = experiment.variations[value.index];
        return __spread(list, [
            {
                experiment: "" + projectGamKeyPrefix + experiment.name.slice(-1),
                variation: variant.name,
            },
        ]);
    }, emptyList);
};
var getFsExperiments = function (enrichedUserProfile, projectGamKeyPrefix) {
    var emptyList = [];
    return enrichedUserProfile.reduce(function (list, _a) {
        var experiment = _a.experiment, variation = _a.variation;
        if (!gamKeyRegex.test(experiment.key)) {
            return list;
        }
        var keyname = "" + projectGamKeyPrefix + experiment.key.slice(-1);
        return __spread(list, [
            {
                experiment: keyname,
                variation: variation.key,
            },
        ]);
    }, emptyList);
};

var createTrackingAdapter = function (optimizely, userId) {
    return function (_a) {
        var eventKey = _a.eventKey, eventTags = _a.eventTags, attributes = _a.attributes, overrideUserId = _a.overrideUserId;
        try {
            var idToTrack = overrideUserId || ensureUserId(optimizely, userId);
            if (idToTrack) {
                optimizely.track(eventKey, idToTrack, attributes, eventTags);
            }
            window.optimizely = window.optimizely || [];
            var webEvent = {
                type: EVENT,
                eventName: eventKey,
                tags: eventTags,
            };
            window.optimizely.push(webEvent);
        }
        catch (e) {
            return;
        }
    };
};

(function (OptimizelyWebPageName) {
    OptimizelyWebPageName["SINS_CHAT_PAGE"] = "16629070839_sins_chat_page";
    OptimizelyWebPageName["SINS_HOME_PAGE"] = "16629070839_sins_home_page";
    OptimizelyWebPageName["SINS_UAE_QUESTION_PAGE"] = "16629070839_sins_uae_question_page";
    OptimizelyWebPageName["SO_CHAT_PAGE"] = "16629070839_so_chat_page";
    OptimizelyWebPageName["SO_UAE_QUESTION_PAGE"] = "16629070839_so_uae_question_page";
    OptimizelyWebPageName["SUB_CHAT_PAGE"] = "16629070839_sub_chat_page";
    OptimizelyWebPageName["SUB_HOME_PAGE"] = "16629070839_sub_home_page";
    OptimizelyWebPageName["SUB_UAE_QUESTION_PAGE"] = "16629070839_sub_uae_question_page";
    OptimizelyWebPageName["SCO_PLAN_SELECTION"] = "sco_plan_selection_step";
    OptimizelyWebPageName["SCO_CHECKOUT"] = "sco_checkout_step";
    OptimizelyWebPageName["SCO_AUTH"] = "sco_plan_auth_step";
    OptimizelyWebPageName["INTERSTITIAL"] = "cspofferinterstitial";
    OptimizelyWebPageName["S2_PLUS_RESUB_MODAL"] = "s2_plus_resub_modal";
})(exports.OptimizelyWebPageName || (exports.OptimizelyWebPageName = {}));
var pushPageToOptimizelyWeb = function (_a) {
    var _b;
    var pageName = _a.pageName, tags = _a.tags, _c = _a.isActive, isActive = _c === void 0 ? true : _c;
    (_b = window.optimizely) === null || _b === void 0 ? void 0 : _b.push(__assign(__assign({ type: 'page', pageName: pageName }, (!isActive && { isActive: isActive })), (tags && isActive && { tags: tags })));
};
/**
 * The Manual trigger fires when a page is pushed using the manual activation API.
 * (https://docs.developers.optimizely.com/web-experimentation/docs/dynamic-websites#manual)
 *
 * @param skip A boolean indicating whether sending the page event should be skipped.
 * @param pageName The "API name" for a page created in Optimizely Web.
 * @param tags (optional) A single-level JSON object with metadata about the content on the page activation with tags.
 */
var useManualOptimizelyWebActivation = function (_a) {
    var skip = _a.skip, pageName = _a.pageName, tags = _a.tags;
    React.useEffect(function () {
        if (skip) {
            return;
        }
        pushPageToOptimizelyWeb({ pageName: pageName, tags: tags });
        return function () { return pushPageToOptimizelyWeb({ pageName: pageName, tags: tags, isActive: false }); };
    }, [skip, pageName]);
};

/**
 * @remarks
 * Allows instantiating an optimizely client in a non-react host app before a userId is known.
 * If a host application uses this method, the optimizely client MUST be instantiated with a `userProfileService` or
 * configuration will fail.
 *
 * @returns
 * Promise when all configuration is complete
 */
var addCheggConfiguration = function (optimizely, userProfileService, _a) {
    var queryStringOnPageLoad = _a.queryStringOnPageLoad, rioConfig = _a.rioConfig, userId = _a.userId;
    var configurationPromise = forceAllocationsOnReady(optimizely, userProfileService, queryStringOnPageLoad, userId);
    if (rioConfig) {
        setInitialRioState(optimizely, rioConfig);
    }
    return configurationPromise;
};
/**
 * @remarks
 * Initialization function to enforce conventions decided by Chegg's Experimentation Working Group.
 * https://chegg.atlassian.net/wiki/spaces/EXP/pages/20757923/Optimizely+Full+Stack+Chegg+On-boarding+Guide
 *
 * Assumes the client application is a React App, and returns instance of `ReactSDKClient`
 *
 * @returns
 * Object with `optimizely`, `userProfileService`, `configurationPromise` and `trackingAdapter` properties
 *
 * configures a client instance with Chegg standardized:
 * 1. cookie persistence / user profile service
 * 2. query string parsing and forced allocation logic
 * 3. rio-sdk plug-n-playability
 *
 * If your use case is not compatible with this init, you can either:
 * - submit a merge request to https://gitlab.com/chegginc/learning-services/devx/chegg-optimizely-sdk and add the functionality!
 * - use the other named exports from this sdk, and compose the functionality you need in your app
 *
 */
var createCheggInstance = function (_a) {
    var cookieDomain = _a.cookieDomain, queryStringOnPageLoad = _a.queryStringOnPageLoad, rioConfig = _a.rioConfig, userId = _a.userId, onActivate = _a.onActivate, projectGamKeyPrefix = _a.projectGamKeyPrefix, rest = __rest(_a, ["cookieDomain", "queryStringOnPageLoad", "rioConfig", "userId", "onActivate", "projectGamKeyPrefix"]);
    var _b = createCookiePersistenceService(cookieDomain, rioConfig), userProfileService = _b.userProfileService, assignContext = _b.assignContext;
    var optimizely = reactSdk.createInstance(__assign(__assign({}, rest), { userProfileService: userProfileService }));
    assignContext(function () { return optimizely.user; });
    persistDevAttribute(optimizely);
    persistQueryStringAttributes(optimizely, queryStringOnPageLoad, cookieDomain);
    // conditionally add activation listener if provided - for sharing experiment allocation information
    if (onActivate) {
        optimizely.notificationCenter.addNotificationListener(optimizelySdk.enums.NOTIFICATION_TYPES.ACTIVATE, onActivate);
    }
    var trackingAdapter = createTrackingAdapter(optimizely);
    var getEnrichedUserProfileWithCaching = getEnrichedUserProfile(optimizely, userProfileService);
    var getCheggExperimentsHeader = createGetCheggExperimentsHeader(getEnrichedUserProfileWithCaching);
    if (projectGamKeyPrefix) {
        setGamGlobal(getEnrichedUserProfileWithCaching, projectGamKeyPrefix);
    }
    return {
        optimizely: optimizely,
        userProfileService: userProfileService,
        trackingAdapter: trackingAdapter,
        getCheggExperimentsHeader: getCheggExperimentsHeader,
        configurationPromise: addCheggConfiguration(optimizely, userProfileService, {
            queryStringOnPageLoad: queryStringOnPageLoad,
            rioConfig: rioConfig,
            userId: userId,
        }),
    };
};

exports.Constants = constants;
exports.SafeOptimizelyFeature = SafeOptimizelyFeature;
exports.addCheggConfiguration = addCheggConfiguration;
exports.createCheggInstance = createCheggInstance;
exports.createGetCheggExperimentsHeader = createGetCheggExperimentsHeader;
exports.createTrackingAdapter = createTrackingAdapter;
exports.createUserProfileCookieService = createCookiePersistenceService;
exports.decodeUserProfileCookie = decode;
exports.default = createCheggInstance;
exports.encodeUserProfileCookie = encode;
exports.forceAllocationsOnReady = forceAllocationsOnReady;
exports.parseForcedAllocations = parseForcedAllocations;
exports.transformToHumanReadable = transformToHumanReadable;
exports.useManualOptimizelyWebActivation = useManualOptimizelyWebActivation;
exports.useSafeOptimizelyFeature = useSafeOptimizelyFeature;
//# sourceMappingURL=index.js.map
